const config = {
  USERNAME: 'aeb-username',
  ROLE: 'aeb-role',
  POINTS: 'aeb-points'
};

export default config;


// WEBPACK FOOTER //
// ./src/config/localStorage.js